import React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { INFLUENCER_CHANNELS_ORDER } from 'utils/influencers';
import { getExternalUrl } from 'utils/url';

type Props = {
  channels: Array<{
    type: 'instagram' | 'youtube' | 'blog',
    url: string
  }>
};

const ChannelIcons = ({
  channels
}: Props) => {
  if (!channels || channels.length === 0) {
    return null;
  }

  const customChannels = {};
  channels.forEach((channel) => {
    customChannels[channel.type] = channel;
  });

  return (
    <section className="channel-icons">
      {
        INFLUENCER_CHANNELS_ORDER.map((channelType, index) => {
          const channel = customChannels[channelType] || { type: channelType, url: '' };

          if (!channel.url) {
            return null;
          }

          return (
            <div className="channel-icons__channel" key={index}>
              <SVGIcon
                name={`${channel.type}-no-customisation`}
                width={24}
                height={24}
                link={getExternalUrl(channel.url || channel.urlRaw)} // `urlRaw` = tiktok default url, not custom FE version
              />
            </div>
          );
        })
      }
    </section>
  );
};

export default ChannelIcons;
